import { lp, ap } from "../../components/mobile/chart-utils";
import {
  Glass,
  Dot,
  ScreenLabel,
  DisplayText,
  BodyText,
  BackNav,
} from "../../components/mobile/primitives";

function JourneyDashboardScreen() {
  const W = 228,
    H = 72,
    PAD = 8;
  const sleepData = [6.8, 7.2, 7.0, 6.5, 7.8, 7.4, 6.9, 7.5, 7.1, 7.6, 7.3, 7.4];
  const sleepLine = lp(sleepData, W, H, PAD, 5.8, 8.2);
  const sleepArea = ap(sleepData, W, H, PAD, 5.8, 8.2);

  return (
    <div style={{ padding: "6px 16px 16px", display: "flex", flexDirection: "column", gap: 9 }}>
      {/* Back */}
      <BackNav label="Skills" color="var(--color-kin-lavender)" />

      {/* Title */}
      <div>
        <div style={{ display: "flex", alignItems: "center", gap: 4, marginBottom: 2 }}>
          <Dot color="var(--color-kin-lavender)" size={5} />
          <ScreenLabel>
            <span style={{ color: "var(--color-kin-lavender)" }}>Skill result</span>
          </ScreenLabel>
        </div>
        <DisplayText size={19}>Sleep Deep Dive</DisplayText>
      </div>

      {/* KPI row */}
      <div style={{ display: "flex", gap: 5 }}>
        {[
          { v: "7.4h", l: "Avg Sleep" },
          { v: "84%", l: "Efficiency" },
          { v: "53ms", l: "Avg HRV" },
        ].map((kpi) => (
          <Glass key={kpi.l} style={{ flex: 1, padding: "7px 5px", textAlign: "center" }}>
            <DisplayText size={14}>{kpi.v}</DisplayText>
            <ScreenLabel>{kpi.l}</ScreenLabel>
          </Glass>
        ))}
      </div>

      {/* Chart */}
      <Glass style={{ padding: "9px 10px 6px" }}>
        <ScreenLabel style={{ marginBottom: 6, display: "block" }}>
          Sleep Duration · 12 nights
        </ScreenLabel>
        <svg viewBox={`0 0 ${W} ${H}`} style={{ width: "100%", height: 72 }}>
          <defs>
            <linearGradient id="jd-sg" x1="0" y1="0" x2="0" y2="1">
              <stop offset="0%" stopColor="var(--color-kin-green-soft)" stopOpacity="0.18" />
              <stop offset="100%" stopColor="var(--color-kin-green-soft)" stopOpacity="0.01" />
            </linearGradient>
          </defs>
          {[0, 1, 2].map((i) => {
            const y = PAD + (i * (H - 2 * PAD)) / 2;
            return (
              <line
                key={i}
                x1={PAD}
                x2={W - PAD}
                y1={y}
                y2={y}
                stroke="rgba(108,108,112,0.10)"
                strokeWidth="0.8"
              />
            );
          })}
          <path d={sleepArea} fill="url(#jd-sg)" />
          <path
            d={sleepLine}
            fill="none"
            stroke="var(--color-kin-green-soft)"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </Glass>

      {/* Key finding */}
      <Glass
        style={{
          padding: "10px 12px",
          background: "linear-gradient(135deg, rgba(165,144,255,0.08), rgba(255,255,255,0.50))",
          border: "1px solid rgba(165,144,255,0.18)",
        }}
      >
        <ScreenLabel style={{ marginBottom: 4, display: "block" }}>
          <span style={{ color: "var(--color-kin-lavender)" }}>Main takeaway</span>
        </ScreenLabel>
        <BodyText size={10} color="var(--color-kin-black)" weight={500} style={{ lineHeight: 1.5 }}>
          Your sleep consistency improved over the last 2 weeks. HRV is trending upward — recovery
          capacity is growing.
        </BodyText>
      </Glass>

      {/* Chat input */}
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: 6,
          background: "rgba(255,255,255,0.60)",
          border: "1px solid rgba(0,0,0,0.10)",
          borderRadius: 14,
          padding: "5px 6px 5px 12px",
        }}
      >
        <BodyText size={9.5} color="var(--color-kin-muted)" weight={400} style={{ flex: 1 }}>
          Ask about your sleep results...
        </BodyText>
        <div
          style={{
            width: 30,
            height: 30,
            borderRadius: 10,
            background: "var(--color-kin-green-soft)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexShrink: 0,
          }}
        >
          <svg width="12" height="12" viewBox="0 0 24 24" fill="none">
            <path
              d="M5 12h14M12 5l7 7-7 7"
              stroke="#fff"
              strokeWidth="2.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </div>
      </div>

      <div style={{ display: "flex", gap: 6 }}>
        <div
          style={{
            flex: 1,
            borderRadius: 12,
            padding: "8px 6px",
            textAlign: "center",
            background: "rgba(255,255,255,0.55)",
            border: "1px solid rgba(0,0,0,0.08)",
          }}
        >
          <BodyText size={8.5} color="var(--color-kin-muted)" weight={700}>
            Choose more skills
          </BodyText>
        </div>
        <div
          style={{
            flex: 1,
            borderRadius: 12,
            padding: "8px 6px",
            textAlign: "center",
            background: "rgba(255,255,255,0.55)",
            border: "1px solid rgba(0,0,0,0.08)",
          }}
        >
          <BodyText size={8.5} color="var(--color-kin-muted)" weight={700}>
            Create your own skill
          </BodyText>
        </div>
      </div>
    </div>
  );
}

export { JourneyDashboardScreen };
